import { render } from "./BandTable.vue?vue&type=template&id=469496bb&scoped=true"
import script from "./BandTable.vue?vue&type=script&lang=js"
export * from "./BandTable.vue?vue&type=script&lang=js"

import "./BandTable.vue?vue&type=style&index=0&id=469496bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469496bb"]])

export default __exports__